var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Texte - petit")]),_c('b-textarea',{model:{value:(_vm.text_small),callback:function ($$v) {_vm.text_small=$$v},expression:"text_small"}}),_c('p',[_vm._v("Texte - grand")]),_c('b-textarea',{model:{value:(_vm.text_big),callback:function ($$v) {_vm.text_big=$$v},expression:"text_big"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }